module.exports = __webpack_public_path__ + "img/WLGHZX_6.bb72e342.jpg";